export type AbtFlagState<T> = {
  flagValue: T | null;
  isLoading: boolean;
};

// Core function to get flag value
export const getAbtFeatureFlag = async <T>(
  flagName: string,
  defaultFlagValue: T,
  attemptsNumber: number = 50,
): Promise<T | null> => {
  return new Promise((resolve) => {
    const mb = window?.mb;

    // If ABT is already initialized, return immediately
    if (mb && mb.abtConfig?.areFlagsFetched === true) {
      const value: T = mb.abtConfig?.visitor
        ?.getFlag(flagName)
        ?.getValue(defaultFlagValue);
      resolve(value);
      return;
    }

    // If attemptsNumber is 0, don't even try polling, just return null, to avoid blocking the UI
    if (attemptsNumber === 0) {
      resolve(null);
      return;
    }

    // Otherwise, poll for a limited number of attempts
    let attempts = 0;
    const intervalId = setInterval(() => {
      const mb = window?.mb;
      if (mb && mb.abtConfig?.areFlagsFetched === true) {
        const value: T = mb.abtConfig?.visitor
          ?.getFlag(flagName)
          ?.getValue(defaultFlagValue);
        clearInterval(intervalId);
        resolve(value);
      } else if (attempts >= attemptsNumber) {
        clearInterval(intervalId);
        resolve(null); // Return null if we've exhausted our attempts
      }
      attempts++;
    }, 100);
  });
};
